<template>
  <div class="work-main">
    <div class="work-main-top">
      <div class="business" @click="$emit('editBusiness')">
        <label>企业信息</label>
        <div class="business-info">
          <img :src="preViewUrl+company.thumb">
          <label>{{company.name}}</label>
        </div>
      </div>
      <div class="direct">
        <div class="direct-title" @click="$emit('editDirect',company.id)">
          <label>直通车计划</label>
        </div>
        <div class="view-offer" @click="$emit('showCurriculumVitae',company.id,true)">
          <label>{{len}}</label>
          <label class="see">查看简历</label>
        </div>
      </div>
      <div class="create-direct" @click="$emit('create-work')">
        <i
          class="el-icon-plus icon create-icon"
        />
        <label>发布岗位</label>
      </div>
    </div>
    <el-table ref="refTable"  @row-click="expandRow" style="margin-top: 10px;width: 100%" :data="data" :row-class-name="rowClassName">
      <el-table-column type="expand" >
        <template slot-scope="{row}">
          <el-form label-position="left"  label-width="110px" class="demo-table-expand" style="margin-left: 10px">
            <el-form-item label="发布时间" >
              <div class="axj-show-club-main-content">
                {{row.created_at|parseTime}}
              </div>
            </el-form-item>
            <el-form-item style="margin-top: -20px"  label="岗位" >
              {{ row.name}}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="薪资" >
              {{row.salary_base}}k-{{row.salary_height}}k
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="工作年限" >
              {{row.experience_base}}-{{row.experience_height}}
            </el-form-item>
            <el-form-item style="margin-top: -20px" label="职位详情" >
              {{row.describe}}
            </el-form-item>

          </el-form>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip label="发布时间"  width="210px" prop="time">
        <template slot-scope="{row}">
          {{ row.created_at|parseTime}}
        </template>
      </el-table-column>
      <el-table-column label="岗位"  width="210px" prop="name">
        <template slot-scope="{row}">
          {{ row.name }}
        </template>
      </el-table-column>
      <el-table-column label="薪资"  width="210px" prop="doSearch">
        <template slot-scope="{row}">
          {{row.salary_base}}k-{{row.salary_height}}k
        </template>
      </el-table-column>
      <el-table-column label="查看简历"  width="150px" prop="doSearch">
        <template slot-scope="{row}">
<!--          {{ row.share_sum }}-->
          <el-button size="mini" type="primary" @click="$emit('showCurriculumVitae',company.id,false,row.id,row)" plain>
            查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column   label="操作">
        <template slot-scope="{row}">
          <axj-button-v2
            button-color="bread"
            button-size="medium"
            button-icon="del1"
            @click="$emit('deleteWork',row.id)"
          ></axj-button-v2>
        </template>
      </el-table-column>
    </el-table>
    <axj-file-preview
      :show-preview.sync="preview.show"
      :preview-file-type="preview.previewFileType"
      :preview-files="preview.previewFiles"
    />

  </div>
</template>

<script>
import AxjButtonV2 from "../../../../../components/common/button/axj-button";
import AxjButton from "../../../../../components/axj-button/index";
import commonModels from '@/common/models/common-models'
import common from '@/common/common'
import Business from "../business/index";
//1、isAuth?直通车计划&查看简历:申请直通车资质-[填写相关信息-admin审核资质]-offer=0?审核通过，发布直通车计划:直通车计划&查看简历
//--1、企业表加一个是否开通字段
//--2、从企业表中查询出是否开通直通车，如果已经开通，就显示查看/编辑直通车计划+查看简历，未开通就显示审核状态|申请开通
//--3、新建一张企业直通车申请表
//--4、申请直通车时，将企业填写的申请信息加入申请表，等待admin审核
//--5、admin审核通过，将企业表的是否开通字段改为是

export default {
  name: "work-main",
  components: {Business, AxjButtonV2, AxjButton},
  props:{
    data:{
      type:Array,
      default:()=>{
        return []
      }
    },
    company:{
      type:Object,
      default:()=>{return{}}
    },
    len:{
      type:Number,
      default:0
    }
  },
  watch:{
    data(v){

    }
  },
  methods:{
    previewWord(x){
      this.preview.previewFileType=x.type
      this.preview.previewFiles=[]
      this.preview.previewFiles.push({
        url:x.url
      })
      this.preview.show=true
    },
    handlePlayVideo(row) {
      if(row.video_url) {
        let url = row.video_url.indexOf('http')>=0?row.video_url:this.resourcePrefix.url+row.video_url
        this.video.url = url
        this.showLovePlayer = true
      }
    },
    handleUpdate(v){
      this.$emit('update',v)
    },
    expandRow(row,index,e){
      let target=e.target
      if(target.className.indexOf('cell')==0||target.className.indexOf('el-tag')==0||target.className.indexOf('el-table')==0){
        this.$refs.refTable.toggleRowExpansion(row)
        return
      }
    },
    rowClassName({row, rowIndex}){
      row.index=rowIndex
      if(rowIndex%2==0){
        return "while-row"
      }else{
        return "gray-row"
      }
    }
  },
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  filters:{
    parseTime(time){
      return commonModels.formatTime(time,'Y/M/D h:m:s')
    },
    arrayImg(v,x){
      let preViewUrl=common.SystemConfig.PreViewUrl
      let array=[]
      array.push(
        preViewUrl+x
      )
      // for (let i =0 ;i<v.length;i++){
      //   if(v[i].url===x.url){
      //     let temp=array[0]
      //     array[0]=preViewUrl+x.url
      //     array.push(temp)
      //   }else{
      //     array.push(preViewUrl+v[i].url)
      //   }
      //
      // }
      return array
    }
  },
  data(){
    return{
      preview:{
        show:false,
        previewFileType:'word',
        previewFiles:[]
      },
      showLovePlayer: false,
      video: {
        url : '',
      },

    }
  }
}
</script>

<style scoped lang="scss">
.work-main{
  .el-tag,.el-tag--info {
    background-color: #41555d;
    /* border-color: #e9e9eb; */
    color: #ffffff;
  }
  .el-table__body tr:hover>td{
    background-color: #f2f5f8 !important;
  }
  .el-table__body tr.current-row>td{
    background-color: #f2f5f8 !important;
  }
  .axj-show-club-main-content{
    line-height: 20px;
    margin-top: 9px;
  }
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .while-row {
    background: #ffffff;
  }
  .el-table .gray-row {
    background: #e8eef0;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
  .el-table .info-row{
    background: #D6D8DC;
  }
  .axj-show-club-main-images{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .axj-show-club-main-dio{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      img{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
    }
    .post-main-word{
      width: 426.888px;
      height: 26.888px;
      border-radius: 10px;
      margin-top: 18.26px;
    }
    .axj-show-club-main-image{
      width: 126.888px;
      height: 126.888px;
      border-radius: 10px;
      margin-top: 18.26px;
      .el-image{
        width: 100%;
        height: 100%;
        width: 126.888px;
        height: 126.888px;
        border-radius: 10px;
      }
    }
    .axj-show-club-main-image:not(:first-child){
      margin-left: 30.5px;
    }
    .axj-show-club-main-image:nth-child(5n+6){
      margin-left: 0px;
    }
  }
  .work-main-top{
    display: flex;
    .business{
      border-radius: 5px;
      width: 260px;
      height: 70px;
      padding: 10px;
      background-color: #ffffff;
      cursor: pointer;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      label{
        font-size: 18px;
        cursor: pointer;
      }
      .business-info:hover{
        color: #00adb5;
      }
      .business-info{
        cursor: pointer;
        align-items: center;
        display: flex;
        label{
          font-size: 16px;
          white-space:nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        img{
          margin-right: 10px;
          width: 40px;
          height: 40px;
          border-radius: 70px;
        }
      }
    }
    .direct{
      margin-left: 20px;
      border-radius: 5px;
      width: 260px;
      height: 90px;
      display: flex;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .direct-title{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 190px;
        height: 70px;
        border-right: 1px solid #eee;
        font-size: 18px;
        label{
          cursor: pointer;
        }
      }
      .direct-title:hover{
        color: #00adb5;

      }
      .view-offer:hover{
        color: #00adb5;
      }
      .view-offer{
        label{
          cursor: pointer;
        }
        height: 100%;
        align-items: center;
        justify-content: center;
        width: 70px;
        display: flex;
        flex-direction: column;
        font-size: 12px;
      }
      background-color: #ffffff;
      cursor: pointer;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }
    .create-direct{
      margin-left: 20px;
      width: 90px;
      border-radius: 5px;
      cursor: pointer;
      height: 90px;
      background: #00adb5;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      box-shadow: 0px 4px 27px rgba(0, 0, 0, 0.02);
      .create-icon{
        font-size: 30px;
        color: white;
      }
      label{
        font-size: 12px;
        color: white;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-service/axj-work/component/work-main/index.vue